<template>
  <div class="company-profile-list-page page-content">
    <el-row class="page-header -with-search-bar" type="flex" justify="space-between">
      <el-col :span="8">
        <h2 class="page-title">ข้อมูลบริษัทสำหรับรับชำระ</h2>
      </el-col>
      <el-col :span="10">
        <el-input
          placeholder="ค้นหารายชื่อบริษัท"
          v-model="searchTerm"
          class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>
      <el-col :span="5">
        <el-button type="primary" class="search-button" @click.prevent="createProfile" v-if="!isViewerRole">
          <span class="text">เพิ่มข้อมูลบริษัท</span> <i class="el-icon-plus el-icon-right"></i>
        </el-button>
      </el-col>
    </el-row>

    <div class="profile-list-table">
      <el-table
        :data="profileListData"
        :default-sort = "{prop: 'name', order: 'ascending'}"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="ชื่อ"
          class-name="no-wrap"
          sortable>
        </el-table-column>
        <el-table-column
          label="ข้อมูล Bill Payment"
          header-align="center"
          align="center">
          <el-table-column
            prop="bill_payment_comp_code"
            label="COMP CODE"
            header-align="center"
            align="center"
            sortable
            :formatter="compCodeFormatter"
            width="120">
          </el-table-column>
          <!--<el-table-column
            prop="bill_payment_account_no"
            label="หมายเลขบัญชี"
            header-align="center"
            align="center"
            sortable
            :formatter="accountNoFormatter"
            width="150">
          </el-table-column>-->
          <el-table-column
            prop="account_no"
            label="หมายเลขบัญชี"
            header-align="center"
            align="center"
            sortable
            width="150">
            <template slot-scope="scope">
              <div
                class="bill-payment-info-row"
                v-if="scope.row.account_no"
                v-html="accountNoAllFormatter(scope.row.account_no)">
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="biller_id"
            label="Biller ID"
            header-align="center"
            align="center"
            sortable
            width="150">
            <template slot-scope="scope">
              <div
                class="bill-payment-info-row"
                v-if="scope.row.biller_id"
                v-html="accountNoAllFormatter(scope.row.biller_id)">
              </div>
            </template>
          </el-table-column>
          <!--<el-table-column
            prop="bill_payment_biller_id"
            label="Biller ID"
            header-align="center"
            align="center"
            sortable
            :formatter="billerIdFormatter"
            width="130">
          </el-table-column>-->
        </el-table-column>
        <el-table-column
          prop="payment_type"
          label="วิธีการชำระเงิน"
          sortable
          header-align="center"
          align="center"
          width="140"
          :formatter="paymentTypeFormatter">
        </el-table-column>
        <el-table-column
          prop="update_at"
          label="วันที่แก้ไข"
          width="120"
          header-align="center"
          align="center"
          sortable
          :formatter="dateFormatter">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="ตัวเลือก"
          header-align="center"
          align="center"
          class-name="action-col"
          width="80">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click.prevent="handleEdit(scope.$index, scope.row)"
              class="action-btn">
              {{ isViewerRole ? 'ดูข้อมูล' : 'แก้ไข' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone';
  // import store from '@/store';
  import { createMask } from 'imask';
  /**
   * Company Profile Form view
   */
  const CompanyProfileListView = {
    name: 'company-profile-list',
    props: ['companyId'],
    data() {
      return {
        isSubmitting: false,
        searchTerm: '',
        mask: {
          compCode: {
            mask: /^\d{0,4}$/,
          },
          accountNo: {
            mask: '000-0-00000-0',
          },
          billerId: {
            mask: /^\d{0,15}$/,
            /* mask: [
              { mask: '0000000000' },
              { mask: '0000000000000' },
            ], */
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      isViewerRole() {
        return this.$store.getters.isViewerRole;
      },
      company() {
        return this.$store.getters.currentCompany;
      },
      profileList() {
        return this.$store.getters.companyProfileList;
      },
      profileListData() {
        const q = this.searchTerm.trim().toLowerCase();
        if (q !== '') {
          return this.profileList.filter((item) => {
            const name = item.name.trim().toLowerCase();
            const bpCompCode = (item.bill_payment_comp_code || '').trim().toLowerCase();
            const bpAccountNo = (item.bill_payment_account_no || '').trim().toLowerCase();
            const bpBillerId = (item.bill_payment_biller_id || '').trim().toLowerCase();
            return name.indexOf(q) !== -1 ||
              bpCompCode.indexOf(q) !== -1 ||
              bpAccountNo.indexOf(q) !== -1 ||
              bpBillerId.indexOf(q) !== -1;
          });
        }
        return this.profileList.map((item) => {
          const profile = JSON.parse(JSON.stringify(item));
          // account no
          const billPaymentAccountNo = this.maskFormatter(profile.bill_payment_account_no,
            this.mask.accountNo);
          let qrAccountNo = null;
          if (profile.barcode_qrcode_account_no) {
            const acc = this.maskFormatter(profile.barcode_qrcode_account_no, this.mask.accountNo);
            qrAccountNo = `${acc} (${profile.barcode_qrcode_account_no_suffix})`;
          }
          profile.account_no = {
            bill_payment: billPaymentAccountNo,
            qr: qrAccountNo,
          };
          // biller_id
          const billPaymentBillerId = this.maskFormatter(profile.bill_payment_biller_id,
            this.mask.billerId);
          let qrBillerId = null;
          if (profile.barcode_qrcode_biller_id_tax_id) {
            qrBillerId = `${profile.barcode_qrcode_biller_id_tax_id} (${profile.barcode_qrcode_biller_id_suffix})`;
          }
          profile.biller_id = {
            bill_payment: billPaymentBillerId,
            qr: qrBillerId,
          };
          return profile;
        });
      },
    },
    methods: {
      backToCompanyDetail() {
        const params = {
          companyId: this.companyId,
        };
        this.$router.push({ name: 'CompanyDetail', params });
      },
      paymentTypeFormatter(row) {
        return row.payment_type === 'CASH_ONLY' ? 'เงินสดอย่างเดียว' : 'เช็ค/เงินสด';
      },
      dateFormatter(row, column, cellValue) {
        const date = moment(cellValue).tz(process.env.DEFAULT_TZ);
        if (date.isValid()) {
          return date.format('ll');
        }
        return '-';
      },
      compCodeFormatter(row, column, cellValue) {
        if (cellValue) {
          return this.maskFormatter(cellValue, this.mask.compCode);
        }
        return '-';
      },
      accountNoFormatter(row, column, cellValue) {
        if (cellValue) {
          return this.maskFormatter(cellValue, this.mask.accountNo);
        }
        return '-';
      },
      accountNoAllFormatter(cellValue) {
        const { bill_payment: billPayment, qr } = cellValue;
        const output = [];
        if (billPayment) {
          output.push(billPayment);
        } else {
          output.push('-');
        }
        if (qr) {
          output.push(qr);
        } else {
          output.push('-');
        }
        if (output.length > 0) {
          return output.join('<br/>');
        }
        return '-';
      },
      billerIdFormatter(row, column, cellValue) {
        if (cellValue) {
          return this.maskFormatter(cellValue, this.mask.billerId);
        }
        return '-';
      },
      maskFormatter(val, maskOptions) {
        const mask = createMask(maskOptions);
        if (val) {
          return mask.resolve(val.toString());
        }
        return '';
      },
      createProfile() {
        this.$router.push({
          name: 'CompanyProfileCreate',
          params: {
            companyId: this.companyId,
          },
        });
      },
      handleEdit(index, row) {
        if (this.isViewerRole) {
          this.$router.push({
            name: 'CompanyProfileDetail',
            params: {
              companyId: this.companyId,
              profileId: row.id,
            },
          });
        } else {
          this.$router.push({
            name: 'CompanyProfileEdit',
            params: {
              companyId: this.companyId,
              profileId: row.id,
            },
          });
        }
      },
      addressFormatter(row) {
        return `${row.address.line_1}
        ${row.address.district}
        ${row.address.city}
        ${row.address.province}
        ${row.address.postal_code}`;
      },
    },
    // Handle Routing
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        // Fetch data
        vm.$store.dispatch('START_CONTENT_LOADING');
        vm.$store.dispatch('GET_COMPANY_PROFILE_LIST', to.params.companyId).then(() => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
        }).catch((err) => {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
          vm.$store.dispatch('ADD_ERROR_FLASH', err);
        });
        vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
      });
    },
  };
  export default CompanyProfileListView;
</script>

<style lang="scss">
  .profile-list-table {
    .bill-payment-info-row {
      line-height: 1.3;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/company/company-profile-list.vue